export default "__VITE_ASSET__6df4bf05__"